var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimefan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.07 105.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.78,72.76a22.46,22.46,0,0,1-9.36,1.62A22.19,22.19,0,0,1,33.32,62c-5.13,8.25-9.16,19.1-8.9,27.51.1,2.94-.11,5.71,2.87,8.08,16,12.77,49.2,8.61,60.94-7.87C71.41,90,65.54,78.89,61.78,72.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.6,33.44c-8.43-8.6-19.51-11.89-30.43-9.16C2.46,26.7,0,49.5,0,51.18-.15,65.37,3.71,77.82,15.49,87.87c1.93-9.67,4.31-19.7,17-27.81a21.36,21.36,0,0,1-1.32-8.4A21.77,21.77,0,0,1,42.6,33.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.13.76C46.58-2.16,24,3.48,18.77,15.18c14.54.49,22.58,5.87,26.49,17A22.37,22.37,0,0,1,73,42.4c2.27-3.31,5-7.21,5.69-8.55C88,15.83,82.08,4.51,62.13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.11,31.53c14.1,14.81,13.14,39.1-2.26,52.6l-5.3-5.71c12.13-10.73,12.72-29.8,1.77-41.63,1-.86,1.91-1.71,2.86-2.58S94.1,32.45,95.11,31.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.48,72l-5.27-5.72A13,13,0,0,0,77.05,48l5.82-5.16C90.57,50.63,90.17,64.53,81.48,72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimefan);
export default __webpack_public_path__ + "static/media/timefan.100344cca6e8c3914e142dc4086e954f.svg";
export { ForwardRef as ReactComponent };